import { APP_COUNTRY } from 'config';
import { ENTERED, ENTERING } from 'react-transition-group/Transition';
import media from 'style-utils/media-queries';
import styled, { css } from 'styled-components';
import { ContentWrapperSliderProps } from '../Drawer.type';

export const DrawerOverlay = styled.div`
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  overflow: hidden;
  right: 0;
  bottom: 0;
  left: 0;
  will-change: opacity;

  ${({ theme: { drawer, zIndexes } }) => `
    z-index: ${zIndexes.drawer.overlay};
    background: ${drawer.overlay.background};
    transition: opacity ${drawer.transitionDurationMs}ms ease-in;
  `};
`;

export const ContentWrapperSlider = styled.div<ContentWrapperSliderProps>`
  display: block;
  will-change: transform;
  position: fixed;

  ${({ theme: { drawer, zIndexes } }) => `
    overflow: ${drawer.slider.overflow};
    z-index: ${zIndexes.drawer.slider};
    background: ${drawer.slider.background};
    max-width: ${drawer.slider.maxWith};
    max-height: ${drawer.slider.maxHeight};
    transition: transform ${drawer.transitionDurationMs}ms ease-in;
  `};

  ${function getPadding() {
    if (APP_COUNTRY === 'fr' || APP_COUNTRY === 'es')
      return css`
        padding-top: var(--betting-banner-height);
        ${media.desktop`padding-top: var(--betting-banner-height-md);`}
      `;
  }}

  ${function getSlider({
    position,
    transitionStatus,
    theme: { drawer },
  }): string {
    const transform =
      transitionStatus === ENTERED || transitionStatus === ENTERING
        ? `translate(0, 0)`
        : drawer.slider[position].closed;

    let positionStyles: string;

    switch (position) {
      case 'top':
        positionStyles = `
          top: 0;
          left: 0;
          width: 100%;
        `;
        break;
      case 'right':
        positionStyles = `
          top: 0;
          right: 0;
          height: 100%;
        `;
        break;
      case 'bottom':
        positionStyles = `
          bottom: 0;
          left: 0;
          width: 100%;
        `;
        break;
      case 'left':
        positionStyles = `
          top: 0;
          left: 0;
          height: 100%;
        `;
        break;
    }

    return `
     ${positionStyles};
      transform: ${transform};
    `;
  }}
`;
